import { render, staticRenderFns } from "./ExpertScroll.vue?vue&type=template&id=0df5e491&scoped=true"
import script from "./ExpertScroll.vue?vue&type=script&lang=js"
export * from "./ExpertScroll.vue?vue&type=script&lang=js"
import style0 from "./ExpertScroll.vue?vue&type=style&index=0&id=0df5e491&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df5e491",
  null
  
)

export default component.exports